/**
 * 🗺️ **구역을 사람 말로** — 단일 정의.
 *
 * ## 🔴 왜 shared 에 있나 (2026-09-02)
 * 같은 표가 두 곳에 손으로 적혀 있었고, **조용히 갈렸다.** 관리자 [📊 방문자수]의 표는
 * `library: "도서관"` 을 갖고 있었는데 그런 구역은 **없다**(구역 이름은 `book` 이다).
 * 그래서 운영 화면이 이렇게 보였다:
 *
 *   도서관 **2**  ·  book **31**
 *
 * 「도서관은 아무도 안 간다」로 읽힌다 — 사실은 31번 갔고, 2는 2026-08-20 옛 기록이다.
 * 운영자가 그 숫자로 「도서관을 줄이자」를 정하면 되돌리기 어렵다.
 *
 * 이름을 여기 한 곳에 두면 새 구역이 생겨도 두 화면이 같이 따라온다. 빠뜨리면
 * **타입이 먼저 막는다**(`Record<ZoneId, string>`).
 *
 * ⚠️ `gyeongju` 를 「체험존」이라 부르지 않는다 — 랜딩 하단의 「체험존」은 **월드 전체 입장**을
 *    뜻해서 아이에게 「체험존에서 체험존으로 간다」가 된다. 구역은 장소 이름(경주)으로 부른다.
 */
import type { ZoneId } from "./index";

/** 구역 이름(아이 화면 HUD·하단 바·관리자 집계 공용). */
export const ZONE_TITLE: Record<ZoneId, string> = {
  lobby: "그림책 마을",
  book: "도서관",
  gyeongju: "경주",
  goods: "굿즈 마켓",
  event: "이벤트 광장",
};

/**
 * 저장된 열쇠를 사람 말로. **모르는 이름은 그대로 보여 준다** — 옛 기록(`library` 등)을
 * 지어낸 이름으로 덮으면 그게 옛 것인지 새 것인지 아무도 못 가른다.
 */
export function zoneSay(key: string): string {
  return (ZONE_TITLE as Record<string, string>)[key] ?? key;
}
